// Active Parts Finder vehicle filter, shared across storefront-page embeds.
//
// The SPA (searchStore) mirrors the currently-selected vehicle
// (make/model/year/engine) to the top window's localStorage under
// `pf.vehicleFilter`. Storefront product-page widgets run OUTSIDE the SPA, so
// they read it from here to stamp the vehicle onto the add-to-cart line `Data`
// — this is the vehicle GW wants stored on the order line item (GW-407).

var VEHICLE_LS_KEY = 'pf.vehicleFilter';

/** The selected vehicle filter { make, model?, year?, engine? }, or null. */
export function readVehicleFilter() {
  try {
    var w = (typeof window !== 'undefined' ? (window.top || window) : undefined);
    var raw = w && w.localStorage ? w.localStorage.getItem(VEHICLE_LS_KEY) : null;
    if (!raw) return null;
    var v = JSON.parse(raw);
    return (v && v.make) ? v : null;
  } catch (e) { return null; }
}

/**
 * Build the add-to-cart `Data` JSON string for the active vehicle, or '' when
 * no vehicle is selected. Matches the shape the React app's cart util sends so
 * the storefront persists a single, consistent structure on the order line.
 */
export function vehicleCartData() {
  var v = readVehicleFilter();
  if (!v) return '';
  return JSON.stringify({
    vehicle: { make: v.make, model: v.model, year: v.year, engine: v.engine },
    capturedFrom: 'parts-finder',
  });
}
